import store from '@/store'

export default {
  /**
   * EQP Tree Store set
   * @param treeObj: object
   * @param treeType: string
   */
  setStoreEqpTree (treeObj, treeType) {
    store.dispatch('eqpTreeSelected', treeObj.detail)
    store.dispatch('eqpTreeLevel', treeObj.level)
    store.dispatch('eqpTreeType', treeType)
  },
  /**
   * Selected Lot History Store set
   * @param selectedList: object
   */
  setSelectedLotHistory (selectedList) {
    store.dispatch('lotHistorySelected', selectedList)
  }
}
